import PropTypes from "prop-types";
import styles from "./ExpandableSection.module.css";
import classNames from "classnames";
import { useState } from "react";
import buttonStyle from "./Button.module.css";

export default function ExpandableSection({ heading, text, isOpenByDefault }) {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);
  const [isHovering, setIsHovering] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <div className={styles.ExpandableSection}>
      <button
        className={classNames(styles.button, buttonStyle.button)}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <p className={styles.heading}>{heading}</p>
        <div className={styles.iconWrapper}>
          <div
            className={classNames({
              [styles.icon]: true,
              [styles.active]: !isOpen,
              [styles.hover]: isHovering,
            })}
          >
            <div
              className={classNames({
                [styles.stripe]: true,
                [styles.vertical]: !isOpen,
                [styles.hover]: isHovering,
              })}
            ></div>
            <div
              className={classNames({
                [styles.stripe]: true,
                [styles.hover]: isHovering,
              })}
            ></div>
          </div>
        </div>
      </button>
      <div
        className={classNames({
          [styles.text]: true,
          [styles.active]: isOpen,
        })}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
}

ExpandableSection.propTypes = {
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  isOpenByDefault: PropTypes.bool.isRequired,
};
